import { createStyleObject } from "@capsizecss/core";
import { suisseBoldMetrics } from "./metrics";

export function capBoldByCapHeight(fontSize, lineGapPx) {
  return {
    fontFamily: suisseBoldMetrics.familyName, // "SuisseIntl-Bold"
    fontWeight: 700,
    ...createStyleObject({
      fontMetrics: suisseBoldMetrics,
      fontSize: fontSize,
      lineGap: lineGapPx,
    }),
  };
}

export const textCap18 = capBoldByCapHeight(18, 0);
export const textCap14 = capBoldByCapHeight(14, 0);
export const textCap16 = capBoldByCapHeight(16, 0);
